import * as yup from 'yup'
import { ERROR_TEMPLATES, testRangeFromString } from '@utils/validators'

yup.addMethod(yup.string, 'range', testRangeFromString)

const yupInstallment = yup.object().shape({
	InstallmentsCount: yup.number().default(0).required(),
	Amount: yup.number().default(0).required(),
	Tan: yup.number().default(0).required(),
	Taeg: yup.number().default(0).required(),
	PrgSimul: yup.number().default(0).required(),
	Erogato: yup.number().default(0).required(),
	ImpServiziFinanz: yup.number().default(0).required(),
	ImpServiziIdentinet: yup.number().default(0).required(),

	Interessi: yup.number().default(0).required(),
	Bollo: yup.number().default(0).required(),
	Rendiconto: yup.number().default(0).required(),
	Istruttoria: yup.number().default(0).required(),
	SpeseGestPrat: yup.number().default(0).required(),
	Dovuto: yup.number().default(0).required(),

})

const schema = yup.object({
	Amount: yup
		.string()
		.range(1500, 30000)
		.transform((value) => value.toString().replace(/\./g, ''))
		.default('0')
		.required(ERROR_TEMPLATES.required),
	MotivationSelected: yup
		.string()
		.required(ERROR_TEMPLATES.required)
		.default(''),

		MotivationDetailSelected: yup.string().default(''),
		DescrMotivazione: yup.string().default(''),
	SelectedInstallment: yupInstallment
		.test('should-not-be-empty', ERROR_TEMPLATES.required, (val, context) => {
			if (Object.keys(val).length === 0) {
				return context.createError({
					path: context.path,
					message: ERROR_TEMPLATES.required,
				})
			}

			return true
		})
		.required(),
	rataConAssicurazione: yupInstallment.optional(),
})

type LoanData = yup.InferType<typeof schema>

export { type LoanData }
export default schema
